import type { QueryClient } from '@tanstack/react-query';

export const CONVERSATIONS_QUERY_KEY = ['conversations'] as const;
export const CONVERSATIONS_UNREAD_COUNT_QUERY_KEY = ['conversations', 'unread-count'] as const;
export const FOUND_OBJECT_STATS_QUERY_KEY = ['found-object-stats'] as const;

export function invalidateMessagingCaches(queryClient: QueryClient): Promise<void> {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: CONVERSATIONS_QUERY_KEY }),
    queryClient.invalidateQueries({ queryKey: CONVERSATIONS_UNREAD_COUNT_QUERY_KEY }),
  ]).then(() => undefined);
}

export function invalidateFoundObjectStats(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({ queryKey: FOUND_OBJECT_STATS_QUERY_KEY });
}
